import React from "react";
import { emojiCodeToUrlMap, getEmojiImageUrl } from "./zaloEmojiMap";

const emojiCodes = Object.keys(emojiCodeToUrlMap).sort((a, b) => b.length - a.length);
const escapedCodes = emojiCodes.map((code) =>
  code.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
);
const regexPattern = `(?:${escapedCodes.join("|")})`;
const emojiPattern = new RegExp(regexPattern, "g");

export function parseZaloEmoji(messageText: string): React.ReactNode[] {
  if (!messageText) {
    return [<span key="empty"></span>];
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  const matches = Array.from(messageText.matchAll(emojiPattern));

  if (matches.length === 0) {
    return [<span key="text-only">{messageText}</span>];
  }

  matches.forEach((match, index) => {
    if (match.index !== undefined && match.index > lastIndex) {
      const textBefore = messageText.slice(lastIndex, match.index);
      if (textBefore) {
        parts.push(<span key={`text-${index}-before`}>{textBefore}</span>);
      }
    }

    const emojiCode = match[0];
    const emojiUrl = getEmojiImageUrl(emojiCode);

    if (emojiUrl) {
      parts.push(
        <img
          key={`emoji-${index}`}
          src={emojiUrl}
          alt={emojiCode}
          style={{
            width: 16,
            height: 16,
            verticalAlign: "middle",
            display: "inline-block",
            margin: "0 1px",
          }}
        />
      );
    } else {
      parts.push(<span key={`emoji-fallback-${index}`}>{emojiCode}</span>);
    }

    if (match.index !== undefined) {
      lastIndex = match.index + match[0].length;
    }
  });

  if (lastIndex < messageText.length) {
    const textAfter = messageText.slice(lastIndex);
    if (textAfter) {
      parts.push(<span key="text-after">{textAfter}</span>);
    }
  }

  return parts.length > 0 ? parts : [<span key="fallback">{messageText}</span>];
}
